module.exports = __webpack_public_path__ + "img/42.dc09cfe8.jpg";